
// Export component.
export const headersStyle = {
  'width': '100%'
}

export const rowStyle = {
  'fontWeight': '500',
  'fontSize': '17px',
  'color': 'var(--chakra-colors-secondaryGray-600)',
  'backgroundColor': 'white',
  'overflow': 'visible !important',
  '&:hover': {
    'backgroundColor': '#F4F7FC'
  }
}

export const headerStyle = {
  'borderRight': '1px solid rgba(216, 227, 252, 1)',
  'color': 'rgb(141, 151, 181)',
  'backgroundColor': 'rgb(244, 247, 253)',
  'fontWeight': 600,
  'fontSize': 'clamp(13px, 1.5vw, 15px)',
  'fontFamily': 'Dm Sans',
  'textAlign': 'center',
  'height': '60px',
  'padding': '8px',

  // Disable blue focus border
  '&:focus, &:focus-visible': {
    outline: 'none',
    boxShadow: 'none',
  },

  '& .MuiDataGrid-columnHeaderTitle': {
    'display': 'flex',
    'flexDirection': 'column',
    'width': '100%',
    'overflow': 'visible'
  }
}

export const cellStyle = {
  'borderRight': '1px solid rgba(216, 227, 252, 1)',
  'color': 'rgb(43, 54, 116)',
  'fontSize': 'clamp(13px, 1.5vw, 15px)',
  'fontWeight': 500,
  'fontFamily': 'Dm Sans',
  'overflow': 'auto !important',
  'overflowX': 'auto !important',
  'whiteSpace': 'nowrap !important',
  'textOverflow': 'clip !important',
  'textAlign': 'center !important',
  'justifyContent': 'center !important',
  'display': 'flex',
  'alignItems': 'center'
}

export const bodyStyle = {
  'border': 1,
  'borderStyle': 'solid',
  'borderRadius': 12,
  'borderColor': '#D8E3FC',
  'color': 'var(--chakra-colors-secondaryGray-600)',
  'padding': 0
}

export const footerStyle = {
  'backgroundColor': '#F4F7FC',
  'borderTop': 'none',
  'borderLeft': '1px solid #d1d5db',
  'borderRight': '1px solid #d1d5db',
  'borderBottom': '1px solid #d1d5db',
  'borderBottomLeftRadius': '12px',
  'borderBottomRightRadius': '12px',



  '& .MuiTablePagination-selectLabel': {
    'fontFamily': 'Dm Sans',
    'fontWeight': 600,
    'fontSize': 'clamp(13px, 1.5vw, 15px)',
    'color': '#4A5568'
  },
  '& .MuiTablePagination-select': {
    'fontFamily': 'Dm Sans',
    'fontSize': 'clamp(13px, 1.5vw, 15px)',
    'fontWeight': 600,
    'color': '#4A5568'
  },
  '& .MuiTablePagination-displayedRows': {
    'color': '#4A5568',
    'fontFamily': 'Dm Sans',
    'fontSize': 'clamp(13px, 1.5vw, 15px)',
    'fontWeight': 600
  }
}
